<ngb-alert
  [type]="type"
  [dismissible]="dismissible"
  (closed)="onClose(alert)">
  {{ getMessage() }}
</ngb-alert>
